import { render, staticRenderFns } from "./LoggedOut.vue?vue&type=template&id=56c84b86"
import script from "./LoggedOut.vue?vue&type=script&lang=ts"
export * from "./LoggedOut.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports